import DraggablePopup from '../../components/DraggablePopup'
import ContactSupportForm from './ContactSupportForm'
import {NO_DRAG_CLASS, supportPopupOffsets, supportPopupPositionStrategy} from './constants'
import $ from '../../alias/jquery'
import View from '../../View'
import {connect} from '../../redux/utils'
import {getSupportFormPosition, getSupportFormPositionStrategy, isLoading, isSupportFormShown} from './selectors'
import {closeSupportForm, setSupportFormPosition} from './actions'
import {bindActionCreators} from 'redux'
import LoadingContainer from '../../util/LoadingContainer'
import {getInsideWindowHeight, getInsideWindowWidth, shiftTo} from '../../atBrowserUtils'

class ContactSupportDraggablePopupContainer extends View {
    constructor({
        closeSupportForm = () => {},
        setSupportFormPosition = () => {},
    } = {}) {
        super()

        this.actions = {
            closeSupportForm,
            setSupportFormPosition,
        }

        this.state = {
            shown: false,
            position: {
                x: null,
                y: null,
            },
            positionStrategy: supportPopupPositionStrategy.FROM_TOP_LEFT,
            loading: false,
        }

        this.onAnyStatePropertyChanged(['position', 'positionStrategy'], () => {
            const position = this._getPopupPosition()
            shiftTo(this.draggablePopup.getEl()[0], position.x, position.y)
        })

        this.onStatePropertyChanged('shown', shown => {
            this.draggablePopup.toggle(shown)
        })

        this.onStatePropertyChanged('loading', loading => {
            this.loadingContainer.setState({loading})
        })
    }

    afterRender() {
        this.supportForm = new ContactSupportForm()
        this.loadingContainer = new LoadingContainer({
            contentComponent: this.supportForm
        })
        this.draggablePopup = new DraggablePopup({
            contentComponent: this.loadingContainer,
            additionalClass: 'supportDraggablePopup',
            additionalId: 'supportDraggablePopupId',
            noDragClass: NO_DRAG_CLASS,
            onShow: () => this.supportForm.onShow(),
            onHide: this.actions.closeSupportForm,
            onDragStop: () => {
                this.actions.setSupportFormPosition({
                    positionStrategy: supportPopupPositionStrategy.FROM_TOP_LEFT,
                    position: {
                        x: this.draggablePopup.getEl()[0].offsetLeft,
                        y: this.draggablePopup.getEl()[0].offsetTop
                    }
                })
            },
        }).init($('body'))
    }

    _getPopupPosition() {
        switch (this.state.positionStrategy) {
            case supportPopupPositionStrategy.CENTER: {
                return {
                    x: (getInsideWindowWidth() - this.draggablePopup.getEl().width()) / 2,
                    y: (getInsideWindowHeight() - this.draggablePopup.getEl().height()) / 2
                }
            }
            case supportPopupPositionStrategy.FROM_BOTTOM_RIGHT: {
                return {
                    x: this.state.position.x - this.draggablePopup.getEl().width() + supportPopupOffsets.LEFT,
                    y: this.state.position.y - this.draggablePopup.getEl().height() + supportPopupOffsets.TOP
                }
            }
            default: {
                return {
                    x: this.state.position.x,
                    y: this.state.position.y
                }
            }
        }
    }
}

export default connect(
    (state) => ({
        shown: isSupportFormShown(state),
        loading: isLoading(state),
        position: getSupportFormPosition(state),
        positionStrategy: getSupportFormPositionStrategy(state),
    }),
    (dispatch) => ({
        closeSupportForm: bindActionCreators(closeSupportForm, dispatch),
        setSupportFormPosition: bindActionCreators(setSupportFormPosition, dispatch),
    })
)(ContactSupportDraggablePopupContainer)




// WEBPACK FOOTER //
// ./web/js/support/supportForm/ContactSupportDraggablePopupContainer.js